import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  const category = params.get("category") || "";
  const marketplace = params.get("marketplace") || "";
  const search = params.get("search") || "";

  useEffect(() => {
    api.get("/categories").then(r => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    if (marketplace) q.set("marketplace", marketplace);
    if (search) q.set("search", search);
    api.get(`/products?${q.toString()}`).then(r => setProducts(r.data)).catch(() => setProducts([])).finally(() => setLoading(false));
  }, [category, marketplace, search]);

  const setFilter = (k, v) => {
    const next = new URLSearchParams(params);
    if (v) next.set(k, v); else next.delete(k);
    setParams(next);
  };

  return (
    <div className="nx-container py-10">
      <div className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <span className="mono text-[11px] text-slate-500">CATALOG</span>
          <h1 className="text-4xl md:text-5xl font-black tracking-tighter mt-1">
            {category || (marketplace === "b2b" ? "Wholesale" : "All products")}
          </h1>
          {search && <p className="mt-2 text-slate-600">Results for "<span className="font-bold">{search}</span>"</p>}
        </div>
        <div className="flex gap-2 flex-wrap">
          <button data-testid="filter-all" onClick={() => setParams(new URLSearchParams())} className={`px-4 py-2 border text-xs mono ${!marketplace && !category ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 hover:border-slate-900"}`}>ALL</button>
          <button data-testid="filter-retail" onClick={() => setFilter("marketplace", "b2c")} className={`px-4 py-2 border text-xs mono ${marketplace === "b2c" ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 hover:border-slate-900"}`}>RETAIL</button>
          <button data-testid="filter-wholesale" onClick={() => setFilter("marketplace", "b2b")} className={`px-4 py-2 border text-xs mono ${marketplace === "b2b" ? "bg-blue-700 text-white border-blue-700" : "border-slate-300 hover:border-blue-700"}`}>B2B/WHOLESALE</button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-8">
        <aside className="hidden md:block">
          <h3 className="mono text-[11px] text-slate-500 mb-3">CATEGORY</h3>
          <ul className="space-y-1">
            <li>
              <button onClick={() => setFilter("category", "")} className={`text-sm text-left w-full py-1 ${!category ? "font-bold text-blue-700" : "text-slate-700 hover:text-slate-900"}`}>All</button>
            </li>
            {categories.map(c => (
              <li key={c}>
                <button data-testid={`cat-filter-${c}`} onClick={() => setFilter("category", c)} className={`text-sm text-left w-full py-1 ${category === c ? "font-bold text-blue-700" : "text-slate-700 hover:text-slate-900"}`}>{c}</button>
              </li>
            ))}
          </ul>
        </aside>

        <div>
          {loading ? (
            <div className="text-center py-24 text-slate-500 mono text-xs">LOADING...</div>
          ) : products.length === 0 ? (
            <div className="text-center py-24">
              <p className="mono text-xs text-slate-500 mb-2">NO/RESULTS</p>
              <p className="text-lg">Nothing found. Try adjusting filters.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="products-grid">
              {products.map(p => <ProductCard key={p.product_id} product={p} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
